import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { SalesPage } from "@/screens/Sales/components/SalesPage"
import { salesOpportunitySearchSchema } from "@/screens/Sales/schemas"

export const Route: AnyRoute = createFileRoute("/app/sales/")({
  validateSearch: zodValidator(salesOpportunitySearchSchema),
  beforeLoad: () => {
    if (window.innerWidth < 1024) {
      throw redirect({ to: "/app/tablet/sales/" })
    }
  },
  component: SalesPage,
})
